module.exports = __webpack_public_path__ + "static/media/DSC_7113.f3a49e07.jpg";